module.exports = __webpack_public_path__ + "img/treatment-satisfaction.27250ad0.svg";